// unique scripts go here.

// const { default: Swal } = require("sweetalert2");

// const { default: MicroModal } = require("micromodal");

const carouselInstancing = () => {
	$('.slides').slick({
		dots: true,
		arrows: false,
		speed: 1200,
		autoplay: true,
		autoplaySpeed: 3000
	});

	if (helpers.isMobile) {
		$('.becomes-carousel-on-mobile').slick({
			speed: 1000,
			arrows: false,
			dots: true,
			fade: true,
			autoplay: true,
			autoplaySpeed: 6000
		});
	}
}

/**
 * @method genericFade
 * @param {Object} e | Event
 *
 * Provides reusability to jquery's fadein/fadeout
 */

const genericFade = e => {
	const target = e.target.dataset.target;
	const inOrOut = e.target.dataset.fade;

	if (target === '' || inOrOut === '') {
		console.error('O alvo dessa função precisa de um atributo data-target e um atributo data-fade');
	}

	inOrOut === 'in' ? ($(target).fadeIn(), helpers.lockBody()) : ($(target).fadeOut(), helpers.unlockBody());
}

function anchors(e) {
	// prevent default click behavior on <a>;
	e.preventDefault();

	// gather need data such as where to scroll and possible offset.
	const el = $(this),
		val = el.prop('href'),
		hash = val.indexOf('#'),
		length = val.length,
		target = val.substring(hash, length),
		offset = $(this).data('offset') != undefined ? $(this).data('offset') : 0,
		hamb = document.querySelector('.hamburger')

	$('html,body').animate({
		scrollTop: $(target).offset().top + offset
	}, 500);

	window.innerWidth < 991 & hamb && hamb.click()
}

/**
 * @method maskInstancing
 * @uses jquery.mask.js <- on src/js/d.mask.js
 *
 * Basic form field masks
 */

const maskInstancing = () => {
	const SPMaskBehavior = function (val) {
			return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
		},
		spOptions = {
			onKeyPress: function (val, e, field, options) {
				field.mask(SPMaskBehavior.apply({}, arguments), options);
			}
		};

	$('input[name="Telefone"], input[name="Celular"], input[name="Telefone Fixo"]').mask(SPMaskBehavior, spOptions);
}

const deferIframes = () => {
	const frames = document.querySelectorAll('iframe');

	setTimeout(() => {
		frames.forEach(frame => {
			let source = frame.dataset.src;
			frame.setAttribute('src', source);
		});
	}, 400);

}

const initModals = () => {
	const btns = document.querySelectorAll('[open-modal]')

	btns && btns.forEach(btn => {
		// console.log(btn)
		btn.addEventListener('click', e => {
			e.preventDefault()
			let attr = btn.getAttribute('data-modal')
			let wrapper = document.getElementById(attr)
			let container = wrapper.children.item(0).children.item(0)
			console.log(wrapper);
			console.log(container);

			MicroModal.show(attr)
			container && container.scrollTo({
				top: 0,
				behavior: 'smooth'
			})
		})
	})
}

const tracker = () => {
	const zapBtns = document.querySelectorAll('.whats-tracker')

	zapBtns && zapBtns.forEach(zap => {
		zap.addEventListener('click', () => {
			ga('gtag_UA_146437414_1.send', 'event', 'WhatsApp', 'Click', 'WhatsApp')
		})
	})
}

const sendMail = () => {
	const forms = document.querySelectorAll('form')

	forms && forms.forEach(form => {
		form.addEventListener('submit', e => {
			e.preventDefault()
			let url = '../../includes/envia.php'
			let formData = new FormData(form)
	
			let request = fetch(url, {
				method: 'POST',
				body: formData
			})

			request.then(response => {
				if( response.status == '200' ) {
					ga('gtag_UA_146437414_1.send', 'event', 'Formulário', 'Envio', 'Formulário')

					Swal.fire({
						title: 'Enviado com sucesso!',
						icon: 'success'
					})

					form.reset()
				}
			})
		})
	})
}